import { ConditionalLink, Icons } from 'components';
import React from 'react';
import styled, { ColorsTypes } from 'styled-components';

const Ul = styled.ul`
  display: flex;
  margin-top: 5px !important;

  ${({ theme: { mediaQueries } }) => {
    return `
      flex-direction: column;

      ${mediaQueries.desktop} {
        flex-direction: row;
      }
    `;
  }}
`;

const Li = styled.li`
  display: flex;
  align-items: center;
`;

const Separator = styled(Icons)`
  margin-left: 6px;
  margin-right: 6px;
  color: ${({ theme }) => theme.colors.gray_400};
`;

const Link = styled(ConditionalLink)`
  display: block;
  font-size: 12px;
  color: ${(props: any) => props.theme.colors[props['data-color']]};

  &:hover {
    text-decoration: underline;
  }
`;

const NoLink = styled.div`
  display: block;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray_400};
  &:hover {
    text-decoration: none;
  }
`;

export interface SearchResultsBreadcrumbProps {
  items: { label: string; link?: string }[];
  index: number;
  linkColor?: ColorsTypes;
}

const SearchResultsBreadcrumb = ({ items, index, linkColor = 'primary_400' }: SearchResultsBreadcrumbProps) => {
  return items ? (
    <Ul>
      {items.map((item, itemIndex) => (
        <Li key={`breadcrumb-${index}-${itemIndex}`}>
          {!!itemIndex && <Separator icon="chevronDoubleRight" size={0.6} />}

          <Link data-color={linkColor} component={NoLink} type={item.link ? 'internal' : 'nolink'} to={item.link || ''}>
            {item.label}
          </Link>
        </Li>
      ))}
    </Ul>
  ) : (
    <></>
  );
};

export default SearchResultsBreadcrumb;
